var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.uiLoading)?[_c('div',_vm._b({class:['zm-skeleton', _vm.animated ? 'is-animated' : '' ]},'div',_vm.$attrs,false),[_vm._l((_vm.count),function(i){return [(_vm.loading)?_vm._t("template",_vm._l((_vm.rows),function(item){return _c('zm-skeleton-item',{key:(i + "-" + item),class:{
              'zm-skeleton__paragraph': item !== 1,
              'is-first': item === 1,
              'is-last': item === _vm.rows && _vm.rows > 1,
            },attrs:{"variant":"p"}})})):_vm._e()]})],2)]:[_vm._t("default",null,null,_vm.$attrs)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }